export default "__VITE_ASSET__CSEjxJjT__"